import { ITextAnswerData, ITextCheckedAnswer } from '@fsd-shared/models/materials';

export const normalizeTextCorrectAnswerData = (correctAnswer: ITextCheckedAnswer): ITextAnswerData => {
    const { data, isCorrect } = correctAnswer;
    return {
        answer: data.selectedOption,
        correctness: isCorrect ? 'correct' : 'incorrect',
    };
};
